/* eslint-disable react/jsx-props-no-spreading */
import {
  QButton,
  QCloseButton,
  QModal,
  QModalActions,
  QModalBody,
  QModalButtonProps,
  QModalHeader,
  QText,
} from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentProps } from '../types';

type ConfirmationModalProps = ModalComponentProps & {
  title?: string;
  buttonProps: QModalButtonProps;
  confirmDataCy?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | 'full';
  cancelLabel?: string;
  children?: React.ReactNode;
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  closeModal,
  title,
  buttonProps,
  confirmDataCy,
  size,
  cancelLabel,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <QModal onClose={closeModal} size={size} isOpen>
      <QModalHeader>
        <QText>{title}</QText>
        <QCloseButton onClick={closeModal} />
      </QModalHeader>
      <QModalBody>{children}</QModalBody>
      <QModalActions>
        <QButton variant="outline" onClick={closeModal}>
          {cancelLabel || t('common.cancel')}
        </QButton>
        <QButton {...buttonProps} data-cy={confirmDataCy}>
          {buttonProps.label}
        </QButton>
      </QModalActions>
    </QModal>
  );
};

ConfirmationModal.defaultProps = {
  title: 'Confirm',
  size: 'md',
};
